import React from 'react';

import { Logo } from '@ergeon/core-components';

import FooterMenu from './FooterMenu';
import FooterTerms from './FooterTerms';
import SocialLinks from './SocialLinks';
import { useFooterMenu } from './useFooterMenu';
import { FooterProps } from './types';

const Footer: React.FC<FooterProps> = ({ ergeonUrl, projectsGalleryUrl }) => {
  const menuColumns = useFooterMenu(ergeonUrl, projectsGalleryUrl);

  return (
    <footer className="border-t border-gray-200 bg-gray-50 py-12 dark:border-gray-800 dark:bg-gray-900">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 md:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="flex flex-col gap-4">
            <Logo href={ergeonUrl} size="large" />
            <SocialLinks />
          </div>
          <FooterMenu columns={menuColumns} />
        </div>
        <FooterTerms ergeonUrl={ergeonUrl} />
      </div>
    </footer>
  );
};

export default Footer;
